var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Download"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M5 15.5L5 16.375C5 17.8247 6.17525 19 7.625 19L16.375 19C17.8247 19 19 17.8247 19 16.375L19 15.5M15.5 12L12 15.5M12 15.5L8.5 12M12 15.5L12 5",
    stroke: "#808080",
    strokeWidth: 1.575,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/Download.a5c11568917b0386c915dd98777d37e4.svg";
export { ForwardRef as ReactComponent };